import "./DeleteAccount.scss";

import { createContext, useContext, useState } from "react";
import DeleteAccountStart from "./DeleteAccountSteps/DeleteAccountStart";
import DeleteAccountVerify from "./DeleteAccountSteps/DeleteAccountVerify";

export const DELETE_ACCOUNT_STEPS = {
    START: 1,
    VERIFY: 2
};

/**
 * @typedef {Object} DeleteAccountContext
 * 
 * @property {number} step
 * @property {React.Dispatch<React.SetStateAction<number>>} setStep
 */

/** @type {React.Context<DeleteAccountContext>} */
const Context = createContext({});

export function useDeleteAccountContext() {
    return useContext(Context);
}

export default function DeleteAccount() {
    const [step, setStep] = useState(DELETE_ACCOUNT_STEPS.START);

    return (
        <div className="__account-settings">
            <Context.Provider value={{ step, setStep }}>
                {step === DELETE_ACCOUNT_STEPS.START && (
                    <DeleteAccountStart />
                )}
                {step === DELETE_ACCOUNT_STEPS.VERIFY && (
                    <DeleteAccountVerify />
                )}
            </Context.Provider>
        </div>
    );
}